<template>
    <li>
        <div class="col col-md-12">
            <div class="row">
                <div class="col col-md-2 col-sm-2 text-center float-sm-left userphoto">
                    <img class="img-circle img-sm" :src="notification.author.profile_url" alt="User Image">
                </div>
                <div class="notification-text col col-md-10 col-sm-10 float-sm-left">
                    <span class="username">{{notification.author.name}} {{notification.author.surname}}</span> on
                    <span class="widget"> <a
                            :href="notification.widget.first_url" onclick="window.goToComments()"> {{notification.widget.title}}</a></span><br>
                    {{notification.comment.content}}
                </div>
            </div>
        </div>
    </li>
</template>
<script>
    export default {
        props: {
            notification: {
                required: true,
                type: Object,
            },
        },
        data: function () {
            return {
                state: 'default',
                data: {
                    content: this.notification.content,
                }
            }
        },

    }
</script>


// WEBPACK FOOTER //
// resources/js/components/admin/NotificationItem.vue